export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00131.ced323b7.png";